import {select} from "../../../../shared/SagaService";
import {Type} from "../../helper";
import {PageType} from "../../../../enums/PageType";

export function* copyLinkItems(transactionInitCase, transactionType, transaction) {
    // Pay Mode:
    if (transactionInitCase === PageType.pay) {
        const linkItems = yield select(state => state.Transaction.linkItems);

        // Part 3: If Pay Mode
        const selectedLinkItem = linkItems.find(linkItem => (
            linkItem.target_transaction_id === transaction.id
        ));
        const linkItemsLessSelected = linkItems.filter(linkItem => (
            linkItem.target_transaction_id !== selectedLinkItem?.target_transaction_id
        )) || [];

        const retLinkItems = [...linkItemsLessSelected];

        // selectedLinkItem may be null, when user has no MULTI_CURRENCY subscription, and
        // is making a payment from invoice of foreign currency
        if (selectedLinkItem) {
            retLinkItems.unshift({
                ...selectedLinkItem,
                apply_amount: transaction.balance,
                balance_after_apply: '0.00',
            });
        }

        return {
            // linkItems: [
            //     {
            //         ...selectedLinkItem,
            //         apply_amount: transaction.balance,
            //         balance_after_apply: '0.00',
            //     },
            //     ...linkItemsLessSelected,
            // ],
            linkItems: retLinkItems,
        };
    }

    // Duplicate Mode:
    if (
        transactionInitCase === PageType.duplicate ||
        transactionInitCase === PageType.copy
    ) {
        switch (transactionType) {
            // Copy Link Items
            case Type.sale_credit_note:
            case Type.purchase_credit_note:
            case Type.sale_payment:
            case Type.purchase_payment:
            case Type.sale_refund:
            case Type.purchase_refund: {
                return {
                    linkItems: yield select(state => state.Transaction.linkItems),
                };
            }
            case Type.contra: {
                const linkItemsWithTableName
                    = yield select(state => state.Transaction.linkItemsWithTableName);
                return {
                    salesLinkItems: linkItemsWithTableName[Type.sale_payment],
                    purchaseLinkItems: linkItemsWithTableName[Type.purchase_payment],
                };
            }
            default:
                break;
        }
    }

    return {};
}
